import React from 'react';
import AppBar from '../../commons/AppBar'
import { Divider, Grid, FormControl, InputLabel, Select, Input, MenuItem, TextField, Button, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import ButtonsModules from '../../commons/ButtonsModules';
import SpecificComponent from '../../commons/SpecificComponent';
import Ws from '../../providers/Ws';
import SiteMap from '../../commons/SiteMap';
import AnalizeFurnizori from './AnalizeFurnizori';
import Utils from '../../providers/Utils';
import InsertNewFurnizor from '../../commons/dialogs/InsertNewFurnizor';
import AnalizeClienti from './Analize';


export default class CecuriSiBileteOrdine extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            mapButtons: [{ id: 'financiarcontabil', label: 'Inapoi Financiar', color: '#900DCB' },
            ],
            listFurnizori: [],
            factura: '',
            furnizor: '',
            listFacturi: [],
            listAllFacturi: [],
            showFacturi: false,
            termen: '',
            suma: '',
            listBilete:[],
            lastIdHead:{},
            openInsertDialog:false,
            openInsertFacturaDialog:false,
            listClienti:[],
            client:'',
            fOrC:1,
            listFOrC:[{id:1, name:'Client'},
                      {id:2, name:'Furnizor'}]
        }
    }

    componentDidMount() {

        this.getBilete()
    }

    getBilete = async () => {
        let ws = new Ws();

        let analize = new AnalizeFurnizori();

        let analizeClienti = new AnalizeClienti();

        let getBilete = ws.customSelect('select * from fin_bilete_ordin', {
            p1: 1
        })

        let _ds =  analize.getDatasetLastMonths(24)

        let _dsClienti =  analizeClienti.getDatasetLastMonths(24)

        let[ds,dsClienti] = await Promise.all([_ds, _dsClienti])

        let clienti = Array.from(analizeClienti.getListaClientiUniciDinDataset(dsClienti))

        // console.warn('ds :', ds);
        let furnizori = Array.from(analize.getListaClientiUniciDinDataset(ds));

  

        let facturi = analize.getFacturiNew()

        let facturiClienti = analizeClienti.getFacturiNew();

        let [b, f, fact,c,factC] = await Promise.all([getBilete, furnizori, facturi,clienti, facturiClienti])

        if (b.Succes) {


            // console.log('getBilete :', b);

            // console.log('f :', f);

            // console.log('fact :', fact);
            // f.unshift('+Adauga furnizor nou')



            this.setState({
                listClienti:c,
                listAllFacturiClienti:factC,
                listFurnizori: f,
                listAllFacturi: fact,
                listBilete: b.Content,
                lastIdHead:ds[0]
            },()=>{
                // console.log('lastIdHEad :', this.state.lastIdHead);
            })

        }


    }

    goTo = (id) => {
        this.props.history.push(`/${id}`)
    }

    changeFurnizor = (ev) => {

        let facturiAll = [...this.state.listAllFacturi]

        let facturiFurnizor = []

        let showFacturi = false

        // console.log('facturiAll :', facturiAll);
        let idx = facturiAll.findIndex(f => f.client === ev.target.value)

        if (idx !== -1) {
            showFacturi = true
            facturiFurnizor = facturiAll[idx].facturiTermenDepasit
            // facturiFurnizor.unshift({document:'+Adauga factura noua', id:0})
            this.setState({
                listFacturi: facturiFurnizor,
                furnizor: ev.target.value,
                showFacturi: showFacturi,
         
            })
        }else if(this.state.furnizor !== '+Adauga furnizor nou'){
            // facturiFurnizor.unshift({document:'+Adauga factura noua', id:0})
            // showFacturi = true
            this.setState({
                listFacturi: facturiFurnizor,
                furnizor: ev.target.value,
                showFacturi: showFacturi,
         
            })
           
        }else{
            this.setState({
                listFacturi: facturiFurnizor,
                furnizor: ev.target.value,
                showFacturi: showFacturi,
                openInsertDialog:true
            })
        }

       



    }

    changeClient = (ev) => {

        let facturiAll = [...this.state.listAllFacturiClienti]

        let facturiClient = []

        let showFacturi = false

        // console.log('facturiAll :', facturiAll);
        let idx = facturiAll.findIndex(f => f.client === ev.target.value)

        if (idx !== -1) {
            showFacturi = true
            facturiClient = facturiAll[idx].facturiTermenDepasit
            // facturiClient.unshift({document:'+Adauga factura noua', id:0})
            this.setState({
                listFacturi: facturiClient,
                client: ev.target.value,
                showFacturi: showFacturi,
         
            })
        }else if(this.state.client !== '+Adauga furnizor nou'){
            // facturiClient.unshift({document:'+Adauga factura noua', id:0})
            // showFacturi = true
            this.setState({
                listFacturi: facturiClient,
                client: ev.target.value,
                showFacturi: showFacturi,
         
            })
           
        }else{
            this.setState({
                listFacturi: facturiClient,
                client: ev.target.value,
                showFacturi: showFacturi,
                openInsertDialog:true
            })
        }

       



    }

    insertBiletOrdin = async () => {
        let ws = new Ws();

        if(this.state.fOrC === 2){
            let objToInsert = {
                furnizor: this.state.furnizor,
                factura: this.state.factura,
                suma: this.state.suma,
                termen: this.state.termen,
                tip:'furnizor'
            }
    
            let insert = await ws.insert('fin_bilete_ordin',objToInsert)
    
            // console.log('insert :', insert);
            if(insert.Succes){
                let listaBilete = [...this.state.listBilete];
    
                objToInsert.id = insert.Content[0].id
                objToInsert.client = null
    
                listaBilete.push(objToInsert)
    
    
                this.setState({listBilete:listaBilete})
    
    
    
            }
    
            // console.log('objToInsert :', objToInsert);
        }else{
            let objToInsert = {
                client: this.state.client,
                factura: this.state.factura,
                suma: this.state.suma,
                termen: this.state.termen,
                tip:'client'
            }
    
            let insert = await ws.insert('fin_bilete_ordin',objToInsert)
    
            // console.log('insert :', insert);
            if(insert.Succes){
                let listaBilete = [...this.state.listBilete];
    
                objToInsert.id = insert.Content[0].id
                objToInsert.furnizor = null
    
                listaBilete.push(objToInsert)
    
    
                this.setState({listBilete:listaBilete})
    
    
    
            }
        }

      
    }


    deleteRow = async(r) =>{
        let ws = new Ws()
    
        let update = ws.update('fin_bilete_ordin', {sters:1}, {id:r.id})

        if(update.Succes){
            let bilete = [...this.state.listBilete]

            let idx = bilete.findIndex(b => b.id === r.id)

            bilete.splice(idx,1)

            this.setState({
                listBilete:bilete
            })
        }
    }


    changeFactura =(ev) =>{

        if(ev.target.value === '+Adauga factura noua'){
            this.setState({factura:ev.target.value, 
                            openInsertFacturaDialog:true})
        }else{
            this.setState({factura:ev.target.value})
        }

    }

    addFactura = () =>{

    }


    render() {
        return (
            <div>
                <AppBar history={this.props.history} title={this.dictionary.appBar.drawer.financiar} />

                <InsertNewFurnizor
                    open={this.state.openInsertFacturaDialog}
                    dialogClose={()=>{this.setState({openInsertFacturaDialog:false})}}
                    title={'Adauga Factura'}
                    numeFurnizor={this.state.furnizor}
                    isDisabled={true}
                    add={this.addFactura}
                    />


                <ButtonsModules history={this.props.history}
                    scop={'Financiar'} />
                <Divider className="pm-divider" />
                <div style={{ textAlign: 'left' }}>
                    {this.state.mapButtons.map((b, idx) => {
                        return (
                            <SiteMap
                                key={idx}
                                b={b}
                                buttonSelected={this.goTo} />

                        )
                    })}
                </div>

                <h1 className='pm-title'>Cecuri si bilete de ordin</h1>

                <Grid className='container' style={{justifyContent:'center'}} container>
                <Grid item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                            <InputLabel htmlFor="resursa">Clienti Sau Furnizori</InputLabel>
                            <Select

                                value={this.state.fOrC || ""}
                                onChange={(ev)=>{this.setState({fOrC:ev.target.value}) }}

                                input={<Input id="resursa" />}>


                                {this.state.listFOrC.map((s, idx) => {
                                    return <MenuItem value={s.id} key={idx}  > {s.name}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                    </Grid>

                    {this.state.fOrC === 2 &&
                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                            <InputLabel htmlFor="resursa">Furnizori</InputLabel>
                            <Select

                                value={this.state.furnizor || ""}
                                onChange={this.changeFurnizor}

                                input={<Input id="resursa" />}>


                                {this.state.listFurnizori.map((s, idx) => {
                                    return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                    </Grid>
                    }
                    {this.state.fOrC === 1 &&
                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4} >
                        <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                            <InputLabel htmlFor="resursa">Clienti</InputLabel>
                            <Select

                                value={this.state.client || ""}
                                onChange={this.changeClient}

                                input={<Input id="resursa" />}>


                                {this.state.listClienti.map((s, idx) => {
                                    return <MenuItem value={s} key={idx}  > {s}</MenuItem>

                                })
                                }
                            </Select>
                        </FormControl>


                    </Grid>
                    }
                  
                    {this.state.showFacturi &&
                        <Grid item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                                <InputLabel htmlFor="resursa">Factura</InputLabel>
                                <Select

                                    value={this.state.factura || ""}
                                    onChange={ this.changeFactura}

                                    input={<Input id="resursa" />}>


                                    {this.state.listFacturi.map((s, idx) => {
                                        return <MenuItem value={s.document} key={idx}  > {s.document}</MenuItem>

                                    })
                                    }
                                </Select>
                            </FormControl>


                        </Grid>
                    }
                    {this.state.showFacturi &&
                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Suma'
                                value={this.state.suma || ''}
                                onChange={(ev) => { this.setState({ suma: ev.target.value }) }}
                                margin="normal"
                                type='number'

                            />

                        </Grid>
                    }
                    {this.state.showFacturi &&
                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Termen'
                                value={this.state.termen || ''}
                                onChange={(ev) => { this.setState({ termen: ev.target.value }) }}
                                margin="normal"
                                type='date'
                                InputLabelProps={{
                                    shrink: true
                                }}

                            />

                        </Grid>
                    }
                    {this.state.showFacturi &&
                        <Grid style={{ width: 'fit-content' }} className="loginButton" item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <Button onClick={this.insertBiletOrdin} style={{ width: 'fit-content' }} className='pm-login-button' variant="outlined">{this.dictionary.comune.save}</Button>
                        </Grid>
                    }

                    {this.state.listBilete.length > 0 &&

                        <Table style={{ width: '90%', margin: 'auto' }}>
                            <TableHead>
                                <TableRow style={{}}>

                                    <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                        Furnizor
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                        Client
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                      Factura
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                     Suma
                                    </TableCell>
                                    <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                       Termen
                                    </TableCell>


                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {this.state.listBilete.map((l, idx) => {
                                    return (
                                        <TableRow style={{ cursor: 'pointer' }} key={idx}>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {l.furnizor}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }}>
                                                {l.client || '---'}
                                            </TableCell>

                                            <TableCell style={{ textAlign: 'center' }} >
                                                {l.factura}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }} >
                                                {l.suma}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }} >
                                                {new Utils().dataPrescurtataRomana(l.termen)}
                                            </TableCell>
                                            <TableCell style={{ textAlign: 'center' }} >
                                                <i onClick={() => { this.deleteRow(l) }} style={{ color: '#dc2b2b' }} className='material-icons'>delete</i>
                                            </TableCell>

                                        </TableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    }

                </Grid>
            </div>
        );
    }
}